<form [formGroup]="form_filtre_demande">
  <div class="div-champ-filtre">
    @if (agentsList$ | async; as agents) {
      <div class="div-field">
        <app-virtual-autocomplete
          label="Emetteur"
          ariaLabel="Nom Prénom"
          [data]="agents"
          [config]="agentConfig"
          [formControl]="emetteurControl"
        ></app-virtual-autocomplete>
      </div>
    }

    @if (showTypeRecrutement && (typeRecrutementList$ | async); as typesRecrutement) {
      <div class="div-field">
        <app-virtual-autocomplete
          label="Type de recrutement"
          ariaLabel="Type de recrutement"
          [data]="typesRecrutement"
          [config]="typeRecrutementConfig"
          [formControl]="typeRecrutementControl"
        ></app-virtual-autocomplete>
      </div>
    }

    @if (showTypeRenouvellement && (typeRenouvellementList$ | async); as typesRenouvellement) {
      <div class="div-field">
        <app-virtual-autocomplete
          label="Type de renouvellement"
          ariaLabel="Type de renouvellement"
          [data]="typesRenouvellement"
          [config]="typeRenouvellementConfig"
          [formControl]="typeRenouvellementControl"
        ></app-virtual-autocomplete>
      </div>
    }

    @if (showDirection && (directionsList$ | async); as directions) {
      <div class="div-field">
        <app-virtual-autocomplete
          label="Direction"
          ariaLabel="Direction"
          [data]="directions"
          [config]="directionConfig"
          [formControl]="directionControl"
        ></app-virtual-autocomplete>
      </div>
    }

    @if (showService && (servicesList$ | async); as services) {
      <div class="div-field">
        <app-virtual-autocomplete
          label="Service"
          ariaLabel="Service"
          [data]="services"
          [config]="serviceConfig"
          [formControl]="serviceFonctionnelControl"
        ></app-virtual-autocomplete>
      </div>
    }

    @if (showNumeroPoste && (postesList$ | async); as postes) {
      <div class="div-field">
        <app-virtual-autocomplete
          label="N° de poste"
          ariaLabel="N° de poste"
          [data]="postes"
          [config]="posteConfig"
          [formControl]="numeroPosteControl"
        ></app-virtual-autocomplete>
      </div>
    }

    @if (showDetenteurPoste() && (agentsDemandesList$ | async); as agents) {
      <div class="div-field">
        <app-virtual-autocomplete
          label="Détenteur du poste"
          ariaLabel="Détenteur du poste"
          [data]="agents"
          [config]="agentConfig"
          [formControl]="detenteurPosteControl"
        ></app-virtual-autocomplete>
      </div>
    }

    @if (showAgentRenouvele && (agentsDemandesList$ | async); as agents) {
      <div class="div-field">
        <app-virtual-autocomplete
          label="Agent à renouveler"
          ariaLabel="Agent à renouveler"
          [data]="agents"
          [config]="agentConfig"
          [formControl]="agentRenouveleControl"
        ></app-virtual-autocomplete>
      </div>
    }

    <div class="div-field">
      <mat-form-field class="field-filtre" floatLabel="always">
        <mat-label>Date de création</mat-label>
        <input
          type="text"
          formControlName="dateCreation"
          appearance="standard"
          matInput
          (click)="pickerDCreaRecrutement.open()"
          [matDatepicker]="pickerDCreaRecrutement"
          placeholder="dd/mm/yyyyy"
          />
          <mat-datepicker-toggle matIconSuffix [for]="pickerDCreaRecrutement"></mat-datepicker-toggle>
          <mat-datepicker #pickerDCreaRecrutement></mat-datepicker>
        </mat-form-field>
      </div>
      <div class="div-field">
        <mat-form-field class="field-filtre field-filtre-select" floatLabel="always">
          <mat-label>Statut</mat-label>
          <mat-select formControlName="statut">
            @for (option of statusOptions; track option) {
              <mat-option [value]="option.value">
                {{ option.viewValue }}
              </mat-option>
            }
          </mat-select>
          @if (statutControl.value) {
            <button
              matSuffix
              mat-icon-button
              aria-label="Clear"
              (click)="clearFilterControl($event, statutControl)"
              >
              <mat-icon>close</mat-icon>
            </button>
          }
        </mat-form-field>
      </div>
      <div class="div-filtre-bouton" style="margin-left: 10px">
        <button mat-stroked-button type="reset" class="mr-5 bt-table-effacer" (click)="resetForm()" style="height: 40px">
          <mat-icon>delete</mat-icon> Effacer tous les filtres
        </button>
        <button mat-raised-button class="mr-5 bt-table-filtrer" (click)="applyFilters()" style="height: 40px; width: 100px">Filtrer</button>
      </div>
    </div>
  </form>
